import React from "react";
import { getSEOData } from "../../../global/utils/constants/seoConfig";
import SEO from "../../../global/components/SEO/SEO";
import TuitorialLibraryBanner from "../Components/TuitorialLibraryBanner";
import TuitorialLibraryInfo from "../Components/TuitorialLibraryInfo";

const TuitorialLibrary = () => {
  const seoData = getSEOData("/tuitorial-library");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <TuitorialLibraryBanner />
      <TuitorialLibraryInfo />
    </>
  );
};

export default TuitorialLibrary;
